import { SET_BUSINESS_GROUP } from '../actions/types';

export default function businessGroupReducer(state = [], action) {
	switch (action.type) {
		case SET_BUSINESS_GROUP:
			return action.payload || [];
		default:
			return state;
	}
}
